import React, { useState } from 'react'

import moment from 'moment'

import { Box, Flex } from 'app/components/design-system-components'
import ActivityItemWithDot from 'app/components/design-system-components/ActivityItemWithDot'
import { LogDetailsModal } from 'app/components/design-system-components/modals/LogDetailsModal'
import { activityTabCategories } from 'app/features/teams/applications/application-activities/ApplicationSideTabs/ApplicationActivityTab'
import { theme } from 'app/match/applicationReportPDF/assets/theme'
import { shortYearDateTimeWithAt } from 'app/utils/datetime/helpers'

export const FeedItem = ({ activityLog, lastItem, category, showIcon }) => {
  const { created_at: createdAt, actor, description, details } = activityLog
  const feedTimestamp = moment(createdAt).format(shortYearDateTimeWithAt)
  const IconCmp = category && activityTabCategories[category]?.icon

  const [detailsModalOpened, seDetailsModalOpened] = useState(false)

  const renderDetailsModal = (details) => {
    const onCloseDetailsModal = () => {
      seDetailsModalOpened(false)
    }

    return (
      <LogDetailsModal
        details={details}
        onDissmiss={onCloseDetailsModal}
        onClose={onCloseDetailsModal}
      />
    )
  }

  const detailsModalCmp = details && renderDetailsModal(details)

  const dateInfo = (
    <Flex alignItems="center">
      {feedTimestamp}{' '}
      {showIcon && IconCmp && (
        <Box ml={2}>
          <IconCmp fontSize={theme.fontSizes[5]} color={theme.colors.gray400} />
        </Box>
      )}
    </Flex>
  )

  const commentInfo = (
    <Box>
      {actor && <strong>{actor}&nbsp;</strong>}
      {description}
    </Box>
  )

  return (
    <>
      <ActivityItemWithDot
        dateInfo={dateInfo}
        actionButtonLabel="view"
        actionButtonClick={() => seDetailsModalOpened(true)}
        hasLink={!!detailsModalCmp}
        commentInfo={commentInfo}
      />
      {detailsModalOpened && detailsModalCmp}
    </>
  )
}
